import CustomVideoPlayer from "../../../../src/components/custom-video-player";
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  CustomVideoPlayer,
  ComponentLayout,
  React
};